module.exports = __webpack_public_path__ + "img/2.4b1e6a10.jpg";